import { Component, type ReactNode } from "react";
import { Button } from "./button";

interface Props {
	children: ReactNode;
	fallback?: ReactNode;
}

interface State {
	hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) return this.props.fallback;
			return (
				<div className="flex flex-col items-center justify-center min-h-[400px] gap-4 p-8">
					<h2 className="text-lg font-semibold text-foreground-default">
						Something went wrong
					</h2>
					<p className="text-sm text-foreground-subtle text-center max-w-md">
						An unexpected error occurred. Please try refreshing the page.
					</p>
					<Button onClick={() => window.location.reload()}>
						Refresh Page
					</Button>
				</div>
			);
		}
		return this.props.children;
	}
}
